export default __webpack_public_path__ + "static/media/TrafficCover.a9d1cfb1.jpg";